import React, { forwardRef, useEffect, useState } from "react";
import { Input, Select } from "antd";
import { Country } from "country-state-city";
import { useTranslation } from "react-i18next";

const { Option } = Select;

const countryOptions = Country.getAllCountries().map((country) => ({
    value: `+${country.phonecode}`,
    label: `${country.flag} +${country.phonecode?.replace('+', '')}`,
    key: `${country.phonecode}-${country.isoCode}`
}));


const PhoneNumberInputWithAnt = forwardRef(({ value = "", status, onChange }, ref) => {
    const { t } = useTranslation();
    const defaultCountry = countryOptions[0];
    const [countryCode, setCountryCode] = useState(defaultCountry.value);
    const [number, setNumber] = useState("");

    useEffect(() => {
        if (value) {
            const matched = countryOptions
                .filter(opt => value.startsWith(opt.value))
                .sort((a, b) => b.value.length - a.value.length)[0];
            if (matched) {
                setCountryCode(matched.value);
                setNumber(value.replace(matched.value, ""));
            }
        }
    }, [value]);

    const handleCountryChange = (val) => {
        if (val.startsWith('++')) {
            val = '+' + val.slice(2);
        }
        setCountryCode(val);
        if (number) onChange?.(val + number);
    };

    const handleNumberChange = (e) => {
        const val = e.target.value;
        setNumber(val);
        const nextValue = val ? countryCode + val : null;
        onChange?.(nextValue);


    };

    return (
        <Input
            ref={ref}
            addonBefore={
                <Select className="notranslate" showSearch value={countryCode} onChange={handleCountryChange} style={{ width: 100 }}>
                    {countryOptions.map((opt) => (
                        <Option key={opt.key} value={opt.value}>
                            {opt.label}
                        </Option>
                    ))}
                </Select>
            }
            status={status}
            value={number}
            onChange={handleNumberChange}
            placeholder={t('form.phoneNumber')}
            type="tel"
        />
    );
});

export default PhoneNumberInputWithAnt;